import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m15.59 16a.41.41 0 0 0 .41-.41v-11.077a.41.41 0 0 0 -.41-.41h-3.693v-3.693a.41.41 0 0 0 -.41-.41h-11.077a.41.41 0 0 0 -.41.41v11.077c0 .227.184.41.41.41h3.693v3.693c0 .226.183.41.41.41zm-.41-.82h-10.258v-10.258h10.258zm-11.078-4.104h-3.282v-10.256h10.256v3.282h-6.563a.41.41 0 0 0 -.41.41v6.564z" })
});
export default SvgDuplicate;
